<template>
  <div class="n-right">
    <!--右侧操作按钮 已经登录-->
    <div class="trueLogin" v-if="isLogin&&user">
      <div
        class="icon-btn avatar col f-right"
        v-if="showPerson"
        style="margin-right:16px;"
        ref="personalMenu"
        @mouseenter="showSelect('personalMenu')"
        @mouseleave="hiddenSelect('personalMenu')"
      >
        <router-link class="router text-btn" tag="button" :to="{name: 'myFavorites'}">
          <a
            class="img"
            :style="{'background-image':'url('+imgBaseUrl+user.avatarFile.key+')'}"
            v-if="user.avatarFile"
          ></a>
          <a class="default" v-else>
            <i class="iconfont icon-people" style="font-size:22px;"></i>
          </a>
        </router-link>

        <div class="select-down-menu" style="width: 190px;">
          <div class="personalMenu" :class="{'vip':user.isVip,'common':user.type==1||user.type==4}">
            <div
              class="designer avatar"
              :class="(user.type === 2 || user.type === 3 || user.isVip === 1) && config.isMtbbs ? 'designer-specail' : ''"
            >
              <div class="img-container">
                <div
                  class="img"
                  v-if="user.avatarFile"
                  :style="{'background-image':'url('+imgBaseUrl+user.avatarFile.key+')'}"
                ></div>
                <div
                  class="img"
                  v-else
                  style=" background: rgb(220, 224, 224);width: 100%;height: 100%;border-radius: 50%"
                >
                  <i
                    class="iconfont icon-people"
                    style="display:inline-block;font-size:30px;color:#CACECE;color:#fff;margin-top: 7px;"
                  ></i>
                </div>
              </div>
              <p class="name">
                <img v-if="user.type==3" src="../../images/icon/qy_icon.png" alt>
                {{user.loginName || user.phone}}
              </p>
              <p
                v-if="(user.type === 1 || user.type === 4 || user.type === 5) && user.isVip === 0"
                class="type-display"
                :style="config.isMtbbs ? {'margin-bottom': 77 + 'px'} : ''"
              >{{user.typeDisplay}}</p>
              <p
                v-if="(user.type === 2 || user.type === 3) && user.isVip === 0"
                class="type-display"
              >
                <span>
                  <img src="../../images/egg/adopt.png" alt>
                </span>
                {{user.typeDisplay}}
              </p>
              <p v-if="user.isVip === 1" class="type-display">
                <img src="../../images/vip/vip_icon1.png" alt>
                {{user.typeDisplay}}
              </p>
              <div class="userButton" v-if="user.type === 1 && user.isVip === 0 && !config.isMtbbs">
                <router-link :to="{path: '/my/personal/accountSetting'}">
                  <span class="suerInfomation">立即认证</span>
                </router-link>
                <span></span>
              </div>
              <div
                class="userButton"
                v-if="(user.type === 4 || user.type === 5) && user.isVip === 0 && !config.isMtbbs"
              >
                <router-link :to="{name: 'myAuthentication'}">
                  <span class="suerInfomation">认证审核中</span>
                </router-link>
                <span style="height: 0px;"></span>
              </div>
              <div
                v-if="(user.type === 2 || user.type === 3 || user.isVip === 1) && user.hasSignined === 0 && !config.isMtbbs"
              >
                <div class="userButton userSign">
                  <span style="background:#F5A623;" @click="signEgg">签到领蛋</span>
                  <span class="qiandaoEgg"></span>
                </div>
                <div class="sign-text">
                  <i class="iconfont icon-calendar"></i>已经签到
                  <span class="day-num">{{user.totalSignedDays}}</span>天&nbsp;&nbsp;明日签到
                  <span class="day-num">+{{user.tomorrowPoints}}</span>
                </div>
              </div>
              <div
                v-if="(user.type === 2 || user.type === 3 || user.isVip === 1) && user.hasSignined === 1 && !config.isMtbbs"
              >
                <div class="userButton">
                  <span style="background:#DCE0E0;color: #6C6F70;cursor: default">今日已签到</span>
                  <span :class="animationClass ? 'beginAnmiation': 'signAnmiation'">
                    +{{user.tomorrowPoints}}
                    <i class="iconfont icon-egg1"></i>
                  </span>
                </div>
                <div class="sign-text">
                  <i class="iconfont icon-calendar"></i>已经签到
                  <span class="day-num">{{user.totalSignedDays}}</span>天&nbsp;&nbsp;明日签到
                  <span class="day-num">+{{user.tomorrowPoints}}</span>
                </div>
              </div>
              <div
                class="button"
                :class="(user.type === 2 || user.type === 3 || user.isVip === 1) && config.isMtbbs ? 'button-specail' : ''"
              >
                <router-link class="left" tag="span" :to="{name:'accountSetting'}">账号设置</router-link>
                <span class="right" @click="logout">退出</span>
              </div>
            </div>
          </div>
        </div>


        
      </div>
      <div class="icon-btn col f-right" ref="notice" style="margin-right:20px;">
        <!--@mouseenter="showSelect('notice')" @mouseleave="hiddenSelect('notice')"-->
        <button class="router text-btn" @click="routerLink('myNotices',false)">
          <Badge :count="newNoticeNum">
            <i class="iconfont icon-smallbell" style="font-size:18px"></i>
          </Badge>
        </button>
      </div>
      <div class="icon-text-btn col f-right" style="margin-right:10px">
        <Tooltip content="我的收藏" placement="bottom">
          <button
            class="router text-btn"
            @click="routerLink('myFavorites',false)"
            style="width: auto;"
          >
            <i class="iconfont icon-collectstar" style="font-size:18px;margin-top:-2px;"></i>
            <!--收藏-->
          </button>
        </Tooltip>
      </div>
      <div class="icon-text-btn col f-right" style="margin-right:10px" v-if="!isWinWidth">
        <button class="router text-btn" @click="routerLink('myOrders',false)">
          <i class="iconfont icon-box" style="font-size:18px"></i>
          我的订单
        </button>
      </div>

      <div class="icon-text-btn col f-right" v-if="isWinWidth" style="margin-left: 5px;">
        <Tooltip content="我的订单" placement="bottom">
          <button
            class="router text-btn"
            @click="routerLink('myOrders',false)"
            style="width: auto;"
          >
            <i class="iconfont icon-box" style="font-size:18px;margin-top:-2px;"></i>
          </button>
        </Tooltip>
      </div>

      <div class="icon-text-btn col f-right" style="margin-right:10px" v-if="!isWinWidth">
        <button class="router text-btn" @click="routerLink('myDetailedLists',false)">
          <i class="iconfont icon-detailedlist1" style="font-size:18px"></i>
          我的清单
        </button>
      </div>

      <div class="icon-text-btn col f-right" v-if="isWinWidth" style="margin-left: 5px;">
        <Tooltip content="我的清单" placement="bottom">
          <button
            class="router text-btn"
            @click="routerLink('myDetailedLists',false)"
            style="width: auto;"
          >
            <i class="iconfont icon-detailedlist1" style="font-size:18px;margin-top:-2px;"></i>
          </button>
        </Tooltip>
      </div>
    </div>
    <!--右侧操作按钮 已经登录-->
    <!--右侧操作按钮 未登录-->
    <span
      v-if="!isLogin&&showPerson && !config.isMtbbs"
      class="f-right"
      @click="login"
      style="margin-right: 10px;cursor:pointer"
    >登录 / 注册</span>
    <span
      v-if="!isLogin&&showPerson && config.isMtbbs"
      class="f-right"
      @click="login"
      style="margin-right: 10px;cursor:pointer;float: right;margin-top: 18px;"
    >登录 / 注册</span>
    <!--右侧操作按钮 未登录-->
    <!--智能报价按钮   class="main-btn spacial"-->
    <div class="icon-text-btn col f-right" v-if="!isWinWidth" style="margin-right:10px;">
      <button class="router text-btn" @click="dingzhi">
        <i class="iconfont icon-coppercash"></i>
        智能询价
      </button>
    </div>
    <div class="icon-text-btn col f-right" v-if="isWinWidth" style="margin-left: 10px;">
      <Tooltip content="智能询价" placement="bottom">
        <button class="router text-btn" @click="dingzhi" style="width: auto;">
          <i class="iconfont icon-coppercash" style="font-size:18px;margin-top:-2px;"></i>
        </button>
      </Tooltip>
    </div>
    <!--上传单品和灵感源-->
    <div
      class="icon-text-btn col f-right upload-img"
      ref="applyPrice"
      v-if="config.isZhulogic"
      @mouseenter="showSelect('applyPrice')"
      @mouseleave="hiddenSelect('applyPrice')"
    >
      <button class="main-btn spacial">
        <i class="iconfont icon-plus-m"></i>
        上传素材
      </button>
      <div class="select-down-menu">
        <p id="shangchuantupian" @click="openUserUpload(1)">
          <i class="iconfont icon-shangchuantupian"></i>
          <span>上传灵感源</span>
        </p>
        <p @click="openUserUpload(2)">
          <i class="iconfont icon-shangpin"></i>
          <span>上传产品</span>
        </p>
      </div>
    </div>
    <user-upload v-if="isLogin&&user" ref="userUpload"></user-upload>
    <egglack-box ref="egglackCC" :type="dialogType2"></egglack-box>
  </div>
</template>
<script>
import api from "../../api/index";
import util from "../../libs/util";
import config from "../../config/config";
import UserUpload from "./my-user-upload";
import egglackBox from "./eggLack.vue";
export default {
  data() {
    return {
      imgBaseUrl: api.common.imgBaseUrl,
      animationClass: false,
      config: config,
      dialogType2: 3,
      isWinWidth: false
    };
  },
  props: {
    showPerson: {
      type: Boolean,
      default: true
    }
  },
  components: { UserUpload, egglackBox },
  computed: {
    user() {
      return this.$store.state.user.info;
    },
    isLogin() {
      if (this.$store.state.user.token) {
        if (!this.user.phone) {
          this.$store.dispatch("getUser");
        }
        if (this.newNoticeNum === undefined) {
          this.$store.dispatch("getNewNoticeNum");
        }
      }
      return this.$store.state.user.token;
    },
    newNoticeNum() {
      return this.$store.state.app.newNoticeNum;
    }
  },
  methods: {
    openUserUpload(type) {
      if (!this.isLogin) {
        this.$store.dispatch("getUser");
        return;
      }
      if (
        this.user.type === 2 ||
        this.user.type === 3 ||
        this.user.isVip === 1
      ) {
        this.$refs.userUpload.open(type);
      } else {
        //跳转到认证页面
        this.$refs.egglackCC.open();
      }
    },
    showSelect(refName) {
      if (refName) {
        this.$refs[refName].querySelector(
          ".select-down-menu"
        ).style.opacity = 1;
        this.$refs[refName].querySelector(
          ".select-down-menu"
        ).style.visibility = "visible";
      }
    },
    hiddenSelect(refName) {
      if (refName) {
        this.$refs[refName].querySelector(
          ".select-down-menu"
        ).style.opacity = 0;
        this.$refs[refName].querySelector(
          ".select-down-menu"
        ).style.visibility = "hidden";
      }
    },
    routerLink(routeName, supportBack, refName) {
      if (refName) {
        this.hiddenSelect(refName);
      }
      if (routeName == "detailedList") {
        api.detailedLists.getDetailedLists().then(res => {
          if (res.total > 0) {
            this.$router.push({ name: "detailedListList" });
          } else {
            this.$router.push({ name: "detailedListOperate" });
          }
        });
      } else if (this.$router.currentRoute.name == routeName) {
        this.$router.go(0);
      }
      let route = {
        name: routeName
      };
      if (supportBack && this.$router.currentRoute.name !== routeName) {
        route.query = {
          redirect: this.$router.currentRoute.fullPath
        };
      }
      this.$router.push(route);
    },
    logout() {
      this.$store.dispatch("clearToken");
      this.$router.replace({ path: "/home/homepage" });
      util.setCookie("CountDown", "", -1);
      this.$router.go(0);
    },
    login() {
      this.$router.replace({
        path: "/login/",
        query: { redirect: this.$router.currentRoute.fullPath }
      });
    },
    signEgg() {
      api.account.signin().then(res => {
        if (res) {
          this.animationClass = true;
          this.$store.dispatch("getUser");
        }
      });
    },
    dingzhi() {
      this.$router.push({ name: "myQuotingenter" });
    },
    winWidth() {
      window.onresize = e => {
        this.isWinWidth = document.body.clientWidth <= 1700;
      };
    },

    onloadOpenUuload() {
      if (this.$route.query.upload) {
        window.setTimeout(() => {
          this.$route.query.upload === "inspiration" && this.openUserUpload(1);
          this.$route.query.upload === "product" && this.openUserUpload(2);
        }, 800);
      }
    }
  },
  mounted() {
    this.isWinWidth = document.body.clientWidth <= 1700;
    this.winWidth();
    this.onloadOpenUuload();
  }
};
</script>
<style scoped type="text/scss" lang="scss">
.col {
  float: left;
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: auto;
  button {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
  &.icon-text-btn button {
    width: 96px;
  }
  &.icon-btn {
    width: 30px;
    height: 50px;
    line-height: 50px;
    margin-right: 4px;
    a {
      line-height: 30px;
      height: 30px;
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
    }
    &.avatar {
      button {
        border-radius: 50%;
        overflow: hidden;
      }
      .img {
        border-radius: 50%;
        overflow: hidden;
        width: 100%;
        height: 100%;
        background: no-repeat 50% / cover;
        background-origin: content-box;
      }
      .default {
        width: 100%;
        height: 100%;
        background: #ffffff;
      }
    }
    button {
      width: 100%;
      padding: 0;
      border-radius: 50%;
      background: transparent;
      box-sizing: border-box;
    }
  }
  > * {
    vertical-align: middle;
  }
  .text-btn {
    color: #6c6f70;
    i.iconfont {
      color: #cacece;
    }
  }
  &:hover {
    .text-btn {
      i.iconfont {
        color: #308697;
      }
      color: #308697;
    }
  }
  .select-down-menu {
    position: relative;
    top: -5px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease-in;
    border-radius: 4px;
    box-shadow: #a2a2a8 0 1px 2px;
    z-index: 3;
    &.collapse {
      width: 200px;
      box-shadow: 0 2px 4px 0 #a2a2a8;
      border-radius: 4px;
      .title {
        background: #fff;
        height: 34px;
        line-height: 34px;
        padding: 0 16px;
        text-align: left;
        span {
          font-size: 14px;
          color: #6c6f70;
          &:last-child {
            font-size: 12px;
            color: #a2a2a8;
            float: right;
            cursor: pointer;
          }
        }
      }
      .ivu-collapse {
        background: #ffffff;
        box-shadow: none;
        border-radius: 0;
        border: 0 none;
      }
    }
    .quotedPriceMenu {
      background: #308697;
      padding: 4px;
      > div {
        height: 94px;
        cursor: pointer;
        padding-top: 20px;
        i {
          font-size: 28px;
          line-height: 28px;
          color: #fff;
          display: block;
        }
        p {
          font-size: 12px;
          margin-top: 10px;
          line-height: 18px;
          color: #fff;
        }
      }
      .local-upload {
        border-top: 1px solid #fff;
      }
    }
    .personalMenu {
      background: #fff;
      width: 190px;
      text-align: center;
      &.vip {
        background: url("../../images/vip/personal_crad_bg.png");
      }
      .avatar .img-container {
        width: 68px;
        height: 68px;
        margin: 0 auto;
        margin-bottom: 12px;
        border-radius: 50%;
        background: #dce0e0;
        overflow: hidden;
        text-align: center;
        .img {
          i {
            color: #fff;
          }
        }
      }
      &.vip .avatar {
        .img-container {
          background-image: url("../../images/vip/gradient_bg.png");
          background-size: 100% 100%;
          background-color: transparent;
          padding: 4px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 8px;
        }
      }
      .designer {
        width: 190px;
        height: 292px;
        text-align: center;
        padding-top: 20px;
        box-sizing: border-box;
      }
      .designer-specail {
        height: 222px;
      }
      &.common .designer {
        height: 260px;
      }
      &.vip .designer {
        padding-top: 24px;
        height: 290px;
      }
      &.vip .designer-specail {
        height: 222px;
      }
      .designer p {
        i {
          font-size: 20px;
          vertical-align: middle;
          color: rgba(244, 208, 60, 0.46);
        }
        vertical-align: middle;
      }
      &.vip .designer p {
        &.name {
          color: #fff;
        }
        &.type-display {
          color: #fff;
          line-height: 18px;
          img {
            width: 18px;
            vertical-align: middle;
            margin-right: 6px;
          }
        }
      }
      .designer {
        p {
          &.name {
            color: #353838;
            font-size: 16px;
            line-height: 20px;
            height: 20px;
            margin-bottom: 5px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            img {
              width: 20px;
              height: 20px;
              vertical-align: top;
            }
          }
          &.type-display {
            font-size: 12px;
            color: #6c6f70;
          }
          span {
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
          }
        }
        .userButton {
          width: 100%;
          text-align: center;
          position: relative;
          line-height: 36px;
          margin: 20px 0;
        }
        .sign-text {
          color: #6c6f70;
          margin-bottom: 20px;
          line-height: 12px;
          i {
            font-size: 12px;
            margin-right: 4px;
          }
          .day-num {
            color: red;
          }
        }
      }
      &.vip .designer .sign-text {
        color: #fff;
        .day-num {
          color: #f5a623;
        }
      }
      .designer {
        .userButton {
          > span:first-child,
          .suerInfomation {
            padding: 10px 32px;
            background: #99c72c;
            border-radius: 100px;
            color: #fff;
            cursor: pointer;
          }
          > {
            span:last-child {
              /*width: 100%;*/
              /*float: left;*/
              /*padding: 0 3px;*/
              /*font-size: 12px;*/
              /*text-align: center;*/
              /*color: #6C6F70;*/
              height: 50px;
              i {
                font-size: 12px;
                vertical-align: middle;
                margin-right: 5px;
              }
            }
            .qiandaoEgg {
              height: 0px !important;
            }
          }
          .signAnmiation {
            position: absolute;
            right: 15px !important;
            top: -20px !important;
            font-size: 20px !important;
            color: #e14b5d;
            vertical-align: middle;
            opacity: 0;
            visibility: hidden;
          }
          .beginAnmiation {
            position: absolute;
            right: 0px !important;
            top: -20px !important;
            font-size: 20px !important;
            color: #e14b5d !important;
            vertical-align: middle;
            opacity: 0;
            visibility: hidden;
            animation: signAnmiationFadein ease-in 0.5s;
            /*animation-fill-mode: forwards;*/
          }
          .signAnmiation i,
          .beginAnmiation i {
            margin-left: 5px;
            color: #f5a623;
            font-size: 30px !important;
            vertical-align: middle;
          }
        }
        .button {
          height: 40px;
          position: absolute;
          width: 100%;
          overflow: hidden;
          margin-top: 2px;
          span {
            width: 95px;
            line-height: 42px;
            text-align: center;
            float: left;
            cursor: pointer;
          }
          .left {
            background: #fff;
            font-size: 12px;
            color: #6c6f70;
            border-top: 1px solid #f2f4f5;
          }
          .right {
            background: #fff;
            font-size: 12px;
            color: #6c6f70;
            border-top: 1px solid #f2f4f5;
            &:hover {
              background: #308697;
              font-size: 12px;
              color: #ffffff;
            }
          }
          .left:hover {
            background: #308697;
            font-size: 12px;
            color: #ffffff;
          }
        }
        .button-specail {
          margin-top: 40px;
        }
      }
      &.vip .designer .button {
        .left:hover,
        .right:hover {
          background: #f4d03c;
          border-color: transparent;
        }
        .left,
        .right {
          background: transparent;
          color: #353838;
          line-height: 40px;
          border-top: 2px solid rgba(53, 56, 56, 0.8);
        }
        position: relative;
        &:after {
          content: "";
          width: 2px;
          height: 42px;
          background-color: rgba(53, 56, 56, 0.8);
          position: absolute;
          top: 0;
          left: 94px;
        }
        &:hover:after {
          background-color: transparent;
        }
      }
      .designer p {
        height: 17px;
        line-height: 17px;
        /*margin-top: 8px;*/
        font-size: 12px;
        color: #6c6f70;
      }
      .title {
        font-size: 12px;
        height: 34px;
        line-height: 34px;
        padding: 0 12px;
        text-align: left;
        i {
          float: right;
          font-size: 14px;
          color: #bfbfbf;
          &:hover {
            color: #6c6f70;
          }
        }
      }
      .menu-item {
        font-size: 14px;
        height: 34px;
        line-height: 34px;
        padding: 0 12px;
        text-align: left;
        display: block;
        border-radius: 0;
        &:hover {
          background: #f2f4f5;
        }
      }
      .logout {
        height: 37px;
        line-height: 37px;
        border-top: 1px solid #f2f4f5;
        font-size: 14px;
        color: #6c6f70;
        cursor: pointer;
        &:hover {
          background: #308697;
          color: #fff;
        }
      }
    }
  }
  .collapse {
    .ivu-collapse > .ivu-collapse-item {
      border-color: #f2f4f5;
      &:first-child {
        border-top: 1px solid #f2f4f5;
      }
      .ivu-collapse-header {
        text-align: left;
        padding: 0 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #353838;
        &:hover {
          background-color: #f2f4f5;
        }
      }
    }
    .ivu-collapse-item .ivu-collapse-content {
      p {
        line-height: 16px;
        text-align: justify;
        color: #6c6f70;
        &.timer {
          margin-bottom: 8px;
          text-align: left;
        }
      }
      .ivu-collapse-content-box {
        padding: 10px 0;
      }
    }
  }
}

.f-right {
  float: right;
  margin-right: 20px;
  button.spacial {
    background: #308697;
    color: #fff;
  }
  &.login-al:first-child {
    margin-right: 0;
  }
}
.upload-img {
  cursor: pointer;
  width: 50px;
  margin-left: -12px;
  width: 90px;
  .main-btn {
    display: inline-block;
    background: #fff;
    height: 44px;
    margin-top: -4px;
    i {
      color: #fff;
      font-size: 20px;
    }
  }
  .select-down-menu {
    width: 130px;
    height: 86px;
    box-shadow: #a2a2a8 0 1px 8px;
    top: -5px;
    border-radius: 4px;
    z-index: 200;
    background: #fff;
    right: 20px;
    padding: 5px 10px;
    p {
      height: 38px;
      line-height: 38px;
      font-size: 12px;
      text-align: left;
      cursor: pointer;
      &:hover {
        color: #308697;
      }
      span {
        display: inline-block;
        margin-left: 3px;
      }
    }
  }
}

.icon-text-btn {
  button {
    * {
      vertical-align: middle;
    }
    i.iconfont {
      font-size: 16px;
      margin-right: 5px;
      display: inline-block;
      vertical-align: top;
    }
  }
}

a {
  &:hover,
  &.router.router-link-active {
    color: #353838;
  }
}

.avatar .select-down-menu {
  /*width: 138px;*/
  left: -110px;
}

@keyframes signAnmiationFadein {
  from {
    opacity: 0.8;
    top: -20px;
    visibility: visible;
  }

  to {
    opacity: 0;
    top: -50px;
    visibility: hidden;
  }
}

.trueLogin {
  float: right;
}

.falseLogin {
  float: right;
  font-size: 14px;
  color: #353838;
  > span {
    cursor: pointer;
    &:hover {
      color: #308697;
    }
  }
}
</style>
